export default __webpack_public_path__ + "static/media/G0085.34I-29353_-17022_0.1666192500000.f3bc8d81.jpg";